<div class="gw-content-body">
  <gatewee-content-page
    [breadcrumb]="breadcrumb"
    [title]="
      'features.settings.parameters.enabledCommunications.whatsapp.label'
        | translate
    "
  >
    <ng-container page-header-actions>
      <gatewee-button
        *ngIf="instance"
        [title]="'features.communications.sendMessageTest' | translate"
        variant="secondary"
        iconName="@tui.send-horizontal"
        (clicked)="openTestMessageDialog()"
      ></gatewee-button>
    </ng-container>

    <div page-body>
      <ng-container *ngIf="instance">
        <div
          class="gw-bg-background-elevation-2 gw-border-base gw-overflow-hidden gw-p-medium"
        >
          <!-- Profile & status -->
          <div
            class="gw-flex gw-flex-wrap gw-items-end gw-gap-medium gw-mb-medium"
          >
            <div class="gw-flex gw-items-center gw-gap-3">
              <app-profile-image
                [name]="instance.profileName"
                [photoUrl]="instance.profilePicUrl"
                [width]="50"
              ></app-profile-image>
              <div>
                <h5
                  class="gw-font-semibold gw-mb-1"
                  [ngClass]="{
                    'gw-text-status-positive': isconnected,
                    'gw-text-status-negative': !isconnected
                  }"
                >
                  {{
                    isconnected
                      ? ('features.communications.connected' | translate)
                      : ('features.communications.disconnected' | translate)
                  }}
                </h5>
                <span class="gw-text-sm gw-text-text-secondary">{{
                  instance.ownerJid | phone
                }}</span>
              </div>
            </div>
            <div class="gw-me-auto">
              <p class="gw-text-xs gw-text-text-secondary gw-mb-0">
                {{ 'features.communications.profile' | translate }}
              </p>
              <span class="gw-text-text-primary">{{
                instance.profileName
                  ? (instance.profileName | translate)
                  : 'N/A'
              }}</span>
            </div>
          </div>

          <!-- Stats -->
          <div
            *ngIf="instance._count"
            class="gw-grid gw-gap-medium gw-mb-medium"
            style="grid-template-columns: repeat(auto-fill, minmax(140px, 1fr))"
          >
            <div
              class="gw-bg-background-elevation-1 gw-border-base gw-p-small gw-border-border-normal"
            >
              <h4
                class="gw-text-sm gw-font-semibold gw-text-text-primary gw-mb-0"
              >
                {{ 'features.communications.contacts' | translate }}
              </h4>
              <span class="gw-text-sm gw-text-text-secondary">{{
                instance._count.Contact
              }}</span>
            </div>
            <div
              class="gw-bg-background-elevation-1 gw-border-base gw-p-small gw-border-border-normal"
            >
              <h4
                class="gw-text-sm gw-font-semibold gw-text-text-primary gw-mb-0"
              >
                {{ 'features.communications.messages' | translate }}
              </h4>
              <span class="gw-text-sm gw-text-text-secondary">{{
                instance._count.Message
              }}</span>
            </div>
            <div
              class="gw-bg-background-elevation-1 gw-border-base gw-p-small gw-border-border-normal"
            >
              <h4
                class="gw-text-sm gw-font-semibold gw-text-text-primary gw-mb-0"
              >
                {{ 'features.communications.chats' | translate }}
              </h4>
              <span class="gw-text-sm gw-text-text-secondary">{{
                instance._count.Chat
              }}</span>
            </div>
          </div>

          <!-- Connect / Disconnect -->
          <div class="gw-flex gw-justify-start">
            <gatewee-button
              [title]="
                (isconnected
                  ? 'features.communications.disconnected'
                  : 'features.communications.connect'
                ) | translate
              "
              [variant]="isconnected ? 'secondary' : 'primary'"
              (clicked)="manageConnection()"
            ></gatewee-button>
          </div>
        </div>
      </ng-container>
    </div>
  </gatewee-content-page>
</div>
